import BubbleSelector from './bubble-selector';

export default BubbleSelector;
